// extracted by mini-css-extract-plugin
export default {"root":"CheckBoatModal_root__mAqbx","modalContent":"CheckBoatModal_modalContent__s5Osb","modalIcon":"CheckBoatModal_modalIcon__ah1V+"};